<script>
import {computed, defineAsyncComponent, onMounted, ref} from "vue";
import MdcMenu from "@/components/MdcMenu/MdcMenu";
import MdcSelect from "@/components/MdcSelect/MdcSelect";
import MainNavigation from "@/components/MainNavigation";
import FooterNavToggle from "@/components/FooterNavToggle";
import TranslateIn from "@/components/TranslateIn";
import SearchOverlay from "@/components/SearchOverlay";
import HeaderSearch from "@/components/HeaderSearch";
import ModalDefault from "@/components/ModalDefault";
import MdcForm from "@/components/Mdc/MdcForm.vue";


import {windowOrientation} from "@/utils";

import {MDCTextField} from '@material/textfield';

export default {
    components: {
        'mdc-accordion': defineAsyncComponent(() => import("@/components/MdcAccordion/MdcAccordion")),
        'mdc-accordion-item': defineAsyncComponent(() => import("@/components/MdcAccordion/MdcAccordionItem")),
        'news-label': defineAsyncComponent(() => import("@/components/NewsLabel")),
        'stage-slider': defineAsyncComponent(() => import("@/components/StageSlider")),
        'content-hub': defineAsyncComponent(() => import("@/components/ContentHub/ContentHub")),
        'news-feed': defineAsyncComponent(() => import("@/components/Newsfeed/Newsfeed")),
        'image-teaser': defineAsyncComponent(() => import("@/components/ImageTeaser")),
        'teaser-triple-slider': defineAsyncComponent(() => import("@/components/TeaserTripleSlider")),
        'sticky-side-buttons': defineAsyncComponent(() => import("@/components/StickySideButtons")),
        'appointment-slider': defineAsyncComponent(() => import("@/components/AppointmentSlider")),
        'counter-circle': defineAsyncComponent(() => import("@/components/CounterCircle")),
        'tab-slider': defineAsyncComponent(() => import("@/components/TabSlider")),
        'two-level-slider': defineAsyncComponent(() => import("@/components/TwoLevelSlider/TwoLevelSlider")),
        'locations-app': defineAsyncComponent(() => import("@/components/LocationsApp")),
        'vertical-slider': defineAsyncComponent(() => import("@/components/VerticalSlider")),
        'theme-slider-vertical': defineAsyncComponent(() => import("@/components/ThemeSliderVertical")),
        'certificates-app': defineAsyncComponent(() => import("@/components/Certificates/CertificatesApp")),
        'products-app': defineAsyncComponent(() => import("@/components/Products/ProductsApp")),
        'search-app': defineAsyncComponent(() => import("@/components/Search/SearchApp")),
        'thumb-nail-slider': defineAsyncComponent(() => import("@/components/ThumbnailSlider/ThumbnailSlider")),
        'job-slider': defineAsyncComponent(() => import("@/components/JobSlider")),
        'badge-icon': defineAsyncComponent(() => import("@/components/BadgeIcon")),
        'newsroom-app': defineAsyncComponent(() => import("@/components/Newsroom/NewsroomApp")),
        'cultural-check': defineAsyncComponent(() => import("@/components/CulturalCheck/App")),
        'panel-slider': defineAsyncComponent(() => import("@/components/PanelSlider/PanelSlider.vue")),
        'animated-icons': defineAsyncComponent(() => import("@/components/AnimatedIcons")),
        'to-top': defineAsyncComponent(() => import("@/components/ToTop")),
        'search-form': defineAsyncComponent(() => import("@/components/Search/SearchForm")),
        'cultural-check-app': defineAsyncComponent(() => import("@/components/CulturalCheckNew/CulturalCheckApp")),
        'modal-default': ModalDefault,
          SearchOverlay,
          HeaderSearch,
          MdcMenu,
          MdcSelect,
          MainNavigation,
          FooterNavToggle,
          TranslateIn,
          MdcForm
    },
    setup() {
        const mobileNavOpen = ref(false);

        //document.body.classList.add("is-auth");

        const toggleMobileNav = (state) => {
            if (state !== undefined) {
                mobileNavOpen.value = state;
            } else {
                mobileNavOpen.value = !mobileNavOpen.value;
            }
            mobileNavOpen.value ?
                document.body.classList.add("page-header__navigation--active") :
                document.body.classList.remove("page-header__navigation--active");
        }

        const modalDefaultContent = ref(null);
        const setModalDefaultContent = (content) => {
            modalDefaultContent.value = content;
        }
        const clearModalDefaultContent = () => {
            modalDefaultContent.value = null;
        }

        const searchOverlay = ref(false);

        const toggleMobileNavClass = computed(() => {
            return {
                'is-active': mobileNavOpen.value
            };
        })
        const isMobile = computed(() => {
            return windowOrientation.value.width < 768;
        });
        const isTabletPortrait = computed(() => {
            return windowOrientation.value.width < 1024;
        });

        const footerMainNav = ref();

        onMounted(() => {
            let textFields = document.querySelectorAll('.mdc-text-field');
            for (let x = 0; x < textFields.length; x++) {
                new MDCTextField(textFields[x]);
            }
            let cookie = getCookie("ab-test");

            if (!cookie) {
                cookie = Math.floor(Math.random() * 2).toString();
                setCookie("ab-test", cookie, 30);
            }

            if (cookie === '1') {
                // Version with searchbar in FlyOut
                document.body.setAttribute('ab-test-marker-searches-related', 'Version A')
            } else {
                document.body.setAttribute('ab-test-marker-searches-related', 'Version B')
                document.querySelector('.page-header__flyout--header .header-search-form').style.display = "none";
            }

            const queryString = window.location.search;
            const urlParams = new URLSearchParams(queryString);
            let elements = document.querySelectorAll("[name*=UtmCampaign]")
            for (let x = 0; x < elements.length; x++) {
                elements[x].value = urlParams.get('utm_campaign');
            }
        })

        function getCookie(cname) {
            let name = cname + "=";
            let decodedCookie = decodeURIComponent(document.cookie);
            let ca = decodedCookie.split(";");
            for (let i = 0; i < ca.length; i++) {
                let c = ca[i];
                while (c.charAt(0) === " ") {
                    c = c.substring(1);
                }
                if (c.indexOf(name) === 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return "";
        }

        function setCookie(cname, cvalue, exdays) {
            const d = new Date();
            d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
            let expires = "expires=" + d.toUTCString();
            document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
        }

        const toggleSearch = () => {
            searchOverlay.value = !searchOverlay.value;
        }

        return {
            isTabletPortrait,
            isMobile,
            toggleMobileNav,
            toggleMobileNavClass,
            toggleSearch,
            searchOverlay,
            modalDefaultContent,
            setModalDefaultContent,
            clearModalDefaultContent
        }
    }
}
</script>

<style lang="scss">
@use "@/scss/main.scss";
</style>
